import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import {
  isAvailabilityRuleV2,
  isDateWithRangesValueV2,
  isDateWithSingleRangeValueV2,
  isFilterValueIntegerRangeV2
} from "PFCore/helpers/filters/type_checks_v2";
import { FilterValueV2 } from "PFTypes/filters_v2";

export const isValueEmpty = (value?: FilterValueV2): boolean => {
  if (isAvailabilityRuleV2(value) || isDateWithRangesValueV2(value)) {
    return isEmpty(value.ranges);
  }

  if (isFilterValueIntegerRangeV2(value)) {
    return isNil(value.gte) && isNil(value.lte);
  }

  if (isDateWithSingleRangeValueV2(value)) {
    return (isNil(value.start) || value.start === "") && (isNil(value.end) || value.end === "");
  }

  if (Array.isArray(value) || typeof value === "object") {
    return isEmpty(value);
  }

  return isNil(value) || value === "";
};
